module.exports = __webpack_public_path__ + "static/media/history-undo.e37c8188.svg";